import { __ } from '@wordpress/i18n';

export const generalStyleTabs = [
	{ name: 'general', title: __('General', 'price-calculator') },
	{ name: 'style', title: __('Style', 'price-calculator') }
];